import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
export default function TableRow({ row, onClick }) {
    return (_jsx("tr", { className: "text-xs font-semibold text-gray-600", children: row.map((value) => {
            let key = uuidv4();
            const tdClass = classNames('px-3 py-6 whitespace-nowrap bt-1 border-gray-200', { 'text-left': isNaN(value) }, { 'text-right': !isNaN(value) });
            return (_jsx("td", { scope: "col", className: tdClass, children: value }, key));
        }) }));
}
;
